import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "hammerl_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Inject auth token into every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

// ---------- Auth ----------
export const register = (email, password, rider_name) =>
  api.post("/auth/register", { email, password, rider_name }).then((r) => r.data);
export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const deleteAccount = () => api.delete("/auth/delete_account").then((r) => r.data);

// ---------- Game (current user) ----------
export const getMyProfile = () => api.get("/me/profile").then((r) => r.data);
export const getMyMessages = () => api.get("/me/messages").then((r) => r.data);
export const sendAction = (text) =>
  api.post("/me/action", { text }).then((r) => r.data);
export const levelUp = (skill_id) =>
  api.post("/me/level-up", { skill_id }).then((r) => r.data);
export const fetchSkillCatalog = () => api.get("/skills/catalog").then((r) => r.data);
export const getMyChallenge = () => api.get("/me/challenge").then((r) => r.data);

// ---------- Public ----------
export const getScoreboard = () => api.get("/scoreboard").then((r) => r.data);
export const getCurrentChallenge = () => api.get("/challenge/current").then((r) => r.data);
export const getNpcRoster = () => api.get("/npcs").then((r) => r.data);

// ---------- Action (non-streaming, robust gegen Mobile-Background) ----------
// Wir verzichten bewusst auf SSE-Streaming, weil mobile Browser Stream-Verbindungen
// im Hintergrund abbrechen → das ermöglichte einen Re-Roll-Exploit. Der nicht-streaming
// Endpoint ist via asyncio.shield() auf dem Server abgesichert: selbst wenn der Browser
// die Verbindung dropt, wird die Aktion zu Ende verarbeitet (Würfel + GM-Antwort + State).
// Long-Timeout (60s) deckt LLM-Latenz ab.
export async function streamAction(text, onEvent, choiceType = null, source = null) {
  const token = getToken();
  let res;
  try {
    res = await fetch(`${API}/me/action`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ text, choice_type: choiceType, source }),
      keepalive: false,
    });
  } catch (netErr) {
    // Network/Background-Abort → Server verarbeitet trotzdem zu Ende (asyncio.shield).
    // UI soll nicht erschrecken: zeige hint, dass die Aktion serverseitig läuft, und reload Profil+Messages.
    const err = new Error(
      "Verbindung wurde kurz unterbrochen. Hammerl verarbeitet deine Aktion trotzdem zu Ende – lade neu, um das Ergebnis zu sehen."
    );
    err.status = 0;
    err.networkAborted = true;
    throw err;
  }
  if (!res.ok) {
    let detail = `Fehler: ${res.status}`;
    try {
      const j = await res.json();
      if (j?.detail) detail = j.detail;
    } catch (e) {
      console.warn("[api.streamAction] Failed to parse error response:", e);
    }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  const result = await res.json();
  // result hat die Form { player_message, gm_message, profile, user, ... }
  // Mappe auf das alte Event-Format, damit GamePage-Logik unverändert bleibt.
  if (result.player_message) {
    onEvent({ type: "player", data: result.player_message });
  }
  onEvent({ type: "done", data: result });
}
